import {
  GENDERS,
  AGE_GROUPS,
  FACIAL_HAIRS,
  GLASSES_VALUES,
  SKIN_TONES,
  HAIR_COLORS,
  HAIR_STYLES,
  EYE_COLORS,
  HEIGHTS,
  BUILDS,
  DRESSES
} from '@gamma/shared/attributes';

// Common characteristics from shared constants
const COMMON_CHARACTERISTICS = {
  Gender: GENDERS,
  AgeGroup: AGE_GROUPS,
  FacialHair: FACIAL_HAIRS,
  Glasses: GLASSES_VALUES,
  Height: HEIGHTS,
  Build: BUILDS,
  SkinTone: SKIN_TONES,
  HairColor: HAIR_COLORS,
  HairStyle: HAIR_STYLES,
  EyeColor: EYE_COLORS,
  Dress: DRESSES
};

/**
 * Generate characteristics for a dataset
 * Dataset-specific characteristics (PersonType, Group) should come from dataset metadata
 * @param {string} dataset - Dataset ID (no longer used, kept for backwards compatibility)
 * @returns {Object} Common characteristics only
 */
export function GenerateCharacteristics(dataset) {
  // Only return common characteristics - dataset-specific ones come from metadata
  return { ...COMMON_CHARACTERISTICS };
}

/**
 * Generate the schema based on the given dataset
 * @param {string} dataset - Dataset ID (no longer used, kept for backwards compatibility)
 * @param {Array<string>} mergedGroups - Optional array of group codes from multiple datasets (IGNORED - Group removed)
 * @returns {Object} Characteristics schema
 */
export function GenerateCharacteristicsForSelector(dataset, mergedGroups = null) {
  // Only return common facial characteristics
  // Group is dataset-specific and not included
  return { ...COMMON_CHARACTERISTICS };
}
